import {
  ADD_NOTICE_TEMPLATE_SUCCESS,
  EDIT_NOTICE_TEMPLATE_SUCCESS,
  GET_NOTICE_TEMPLATE_BY_ID_FAILURE,
  GET_NOTICE_TEMPLATE_BY_ID_SUCCESS,
  DELETE_NOTICE_TEMPLATE_SUCCESS,
  GET_NOTICE_TEMPLATES,
  GET_NOTICE_TEMPLATES_SUCCESS,
  GET_NOTICE_TEMPLATES_FAILURE,
  GET_MORE_NOTICE_TEMPLATES_SUCCESS,
  HIDE_NOTICE_TEMPLATES_LOADER,
  SHOW_NOTICE_TEMPLATES_LOADER,
  CLEAR_NOTICE_TEMPLATES_REDUCER,
} from '../constants/ActionTypes';

const INIT_STATE = {
  loading: false,
  templateById: {},
  // `error` is null when no fetch has failed yet (initial state or after
  // a successful fetch). Set to a non-null value when GET_NOTICE_TEMPLATES
  // fails so TemplatesList can distinguish empty-list from fetch-failed.
  error: null,
  templates: {
    list: [],
    pageCount: 0,
    recentlyAdded: [],
  },
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case ADD_NOTICE_TEMPLATE_SUCCESS: {
      const templates = [action.payload.template, ...state.templates.recentlyAdded];
      return {
        ...state,
        loading: false,
        templates: {
          ...state.templates,
          recentlyAdded: templates,
        },
      };
    }
    case EDIT_NOTICE_TEMPLATE_SUCCESS: {
      const { template: edited } = action.payload;
      const list = state.templates.list.slice();
      const index = list.findIndex(template => template.id === edited.id);
      const recentlyAdded = state.templates.recentlyAdded.slice();
      const recentlyAddedIndex = recentlyAdded.findIndex(template => template.id === edited.id);

      if (index >= 0) {
        list[index] = edited;
      } else if (recentlyAddedIndex >= 0) {
        recentlyAdded[recentlyAddedIndex] = edited;
      }

      const templateById = state.templateById.id === edited.id ? edited : state.templateById;

      return {
        ...state,
        templateById,
        templates: {
          ...state.templates,
          list,
          recentlyAdded,
        },
      };
    }
    case GET_NOTICE_TEMPLATE_BY_ID_FAILURE: {
      return {
        ...state,
        templateById: {},
      };
    }
    case GET_NOTICE_TEMPLATE_BY_ID_SUCCESS: {
      return {
        ...state,
        templateById: action.payload.template,
      };
    }
    case GET_NOTICE_TEMPLATES: {
      // Clear any prior error when a fresh fetch is dispatched so a successful
      // retry transitions back to the empty-or-data state.
      return state.error === null ? state : { ...state, error: null };
    }
    case GET_NOTICE_TEMPLATES_SUCCESS: {
      return {
        ...state,
        error: null,
        templates: {
          ...state.templates,
          list: action.payload.templates,
          pageCount: action.payload.pageCount,
        },
      };
    }
    case GET_NOTICE_TEMPLATES_FAILURE: {
      return {
        ...state,
        error: action.payload.error || true,
      };
    }
    case DELETE_NOTICE_TEMPLATE_SUCCESS: {
      return {
        ...state,
        templates: {
          ...state.templates,
          recentlyAdded: action.payload.templates,
        },
      };
    }
    case GET_MORE_NOTICE_TEMPLATES_SUCCESS: {
      const list = state.templates.list.slice().concat(action.payload.templates);
      return {
        ...state,
        templates: {
          ...state.templates,
          list,
          pageCount: action.payload.pageCount,
        },
      };
    }
    case HIDE_NOTICE_TEMPLATES_LOADER: {
      return {
        ...state,
        loading: false,
      };
    }
    case SHOW_NOTICE_TEMPLATES_LOADER: {
      return {
        ...state,
        loading: true,
      };
    }
    case CLEAR_NOTICE_TEMPLATES_REDUCER: {
      return INIT_STATE;
    }
    default:
      return state;
  }
};
